module.exports = __webpack_public_path__ + "static/media/CovCustomerCount.5dd5b795.svg";